class ProductSubscription {
    constructor(container) {
        this.container = container;
        this.formId = this.container.dataset.productForm;
        this.form = document.querySelector(`#${this.formId}`);
        this.isSupplement = container.dataset.isSupplement === 'true';

        if (this.isSupplement) {
            this.planInput = document.querySelector(`input[name="selling_plan"][form="${this.formId}"]`) ||
                document.createElement('input');

            if (!this.planInput.name) {
                this.planInput.type = 'hidden';
                this.planInput.name = 'selling_plan';
                this.planInput.setAttribute('form', this.formId);
                this.form.appendChild(this.planInput);
            }

            // this.variantInput = this.form.querySelector('input[name="id"]');
            // if (!this.variantInput) {
            //     this.variantInput = document.createElement('input');
            //     this.variantInput.type = 'hidden';
            //     this.variantInput.name = 'id';
            //     this.form.appendChild(this.variantInput);
            // }
        } else {
            this.planInput = document.querySelector(`input[name="selling_plan"][form="${this.formId}"]`);
            if (!this.planInput) {
                this.planInput = document.createElement('input');
                this.planInput.type = 'hidden';
                this.planInput.name = 'selling_plan';
                this.planInput.setAttribute('form', this.formId);
                this.form.appendChild(this.planInput);
            }

            this.variantInput = this.form.querySelector('input[name="id"]');
        }
        this.buttons = this.container.querySelectorAll('[data-subscription-button]');
        this.variants = this.isSupplement ? (window.product?.variants || []) : [];

        this.init();
        this.initVariantListener();
    }
    getVariantById(variantId) {
        return this.variants.find(v => v.id.toString() === variantId?.toString());
    }

    init() {
        // Run handleVariantChange at start to configure plans correctly
        this.handleVariantChange();

        // Select first subscription plan by default
        const firstSubscriptionButton = Array.from(this.buttons).find(button =>
            button.dataset.planType === 'subscription'
        );

        if (firstSubscriptionButton) {
            const planId = firstSubscriptionButton.dataset.planId;
            if (planId && this.planInput) {
                this.planInput.value = planId;
                this.buttons.forEach(btn => btn.classList.remove('is-active'));
                firstSubscriptionButton.classList.add('is-active');
            }
        }
      
        this.buttons.forEach(button => {
            button.addEventListener('click', this.handlePlanSelect.bind(this));
        });

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    initVariantListener() {
        window.addEventListener('popstate', this.handleVariantChange.bind(this));

        const pushState = history.pushState;
        const replaceState = history.replaceState;

        history.pushState = function () {
            pushState.apply(history, arguments);
            window.dispatchEvent(new Event('pushstate'));
        };

        history.replaceState = function () {
            replaceState.apply(history, arguments);
            window.dispatchEvent(new Event('replacestate'));
        };

        window.addEventListener('pushstate', this.handleVariantChange.bind(this));
        window.addEventListener('replacestate', this.handleVariantChange.bind(this));
    }

    handleVariantChange() {
        const variantPrice = document.querySelector('[data-product-price]');
        if (variantPrice) {
            const priceText = variantPrice.textContent.trim();
            const variant = {
                price: this.extractPrice(priceText)
            };
            this.updatePrices(variant);

            // Looks for first button with a subscription plans
            const subscriptionButton = Array.from(this.buttons).find(btn => 
                btn.dataset.planType && 
                btn.dataset.planType !== 'onetime'
            );

            if (subscriptionButton) {
                // Remove active class
                this.buttons.forEach(btn => {
                    btn.classList.remove('is-active');
                });
                
                subscriptionButton.classList.add('is-active');
                this.planInput.value = subscriptionButton.dataset.planId || '';
            }
        }
    }

    extractPrice(priceString) {
        return parseInt(priceString.replace(/[^0-9]/g, ''));
    }

    updatePrices(variant) {
      if (!this.isSupplement) {
          this.buttons.forEach(button => {
              const priceElement = button.querySelector('.subscription-price');
              const planType = button.dataset.planType;
  
              if (planType === 'onetime') {
                  priceElement.textContent = this.formatMoney(variant.price);
              } else {
                  const discountText = button.querySelector('.subscription-discount');
                  if (discountText) {
                      const discountPercent = 10;           
                      //const discountMatch = discountText.textContent.match(/\d+/);
                      //const discountPercent = discountMatch ? parseInt(discountMatch[0]) : 0;
                      const discountAmount = (variant.price * discountPercent) / 100;
                      const finalPrice = variant.price - discountAmount;
                      priceElement.textContent = this.formatMoney(finalPrice);
                  }
              }
          });
      } 
    }

    formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    }

    async handleSubmit(event) {
        event.preventDefault();

        const quantity = this.form.querySelector('[name="quantity"]')?.value || 1;
        const variantId = this.variantInput?.value;

        if (!variantId) return;

        const formData = {
            items: [{
                id: variantId,
                quantity: parseInt(quantity),
                selling_plan: this.planInput.value || undefined
            }]
        };

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const cart = await response.json();
            window.dispatchEvent(new CustomEvent('product:added', {
                detail: { cart }
            }));

        } catch (error) {
            window.dispatchEvent(new CustomEvent('product:error', {
                detail: { error }
            }));
        }
    }

    handlePlanSelect(event) {
        const button = event.currentTarget;
        const buttonData = {
            planType: button.dataset.planType || 'onetime',
            planId: button.dataset.planId,
            variantId: button.dataset.variantId
        };

        this.buttons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');

        this.planInput.value = buttonData.planType === 'onetime' ? '' : buttonData.planId;

        const selectedPrice = button.querySelector('.subscription-price').textContent;

        const mainPriceElement = document.querySelector('[data-product-price]');
        if (mainPriceElement) {
            mainPriceElement.textContent = selectedPrice;
        }

        if (this.isSupplement && buttonData.variantId) {

            const inputId = button.closest('.product__subs__wrap').querySelector("input[name='id']")
            inputId.value = buttonData.variantId;
            // fix for supplements

            //this.variantInput.value = buttonData.variantId;
            // const variant = this.getVariantById(buttonData.variantId);
            // if (variant) {
            //     const inputs = document.querySelectorAll('[data-single-option-selector][type="radio"]');
            //     inputs.forEach(input => {
            //         if (input.value === variant.title) {
            //             input.checked = true;
            //             input.dispatchEvent(new Event('change', { bubbles: true }));
            //         }
            //     });
            // }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const subscriptionContainers = document.querySelectorAll('[data-subscription-selectors]');
    subscriptionContainers.forEach(container => {
        new ProductSubscription(container);
    });
});

window.ProductSubscription = ProductSubscription;
